<template>
  <div class="ad-page">
    <div>
      <div class="privilege-detail">
        <span class="title">权限编辑</span>
      </div>
      <div class="privilege-detail">
        <span>角色权限</span>
        <el-input placeholder="请输入角色权限" v-model="roleName"></el-input>
      </div>
      <div class="privilege-detail privilege-detailRE">
        <span>权限配置</span>
        <div class="tree">
          <el-tree
            :data="data"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            :default-checked-keys="default_checked"
          >
          </el-tree>

          <div class="privilege_game">
            <em>数值权限：</em>
            <div class="ban-checkbox">
              <div
                v-for="(item,key) in fieldList"
                :key="key">
                <em>{{item.label}}:</em>
                <el-checkbox-group v-model="fieldObj" size="small">
                  <el-checkbox
                    v-for="field in item.list"
                    :label="field.route + '&&' + field.key"
                    :key="field.key">{{field.label}}</el-checkbox>
                </el-checkbox-group>

              </div>
            </div>
          </div>

          <div class="privilege_game">
            <em>游戏权限：</em>
            <div>
              <div class="select-all">
                <span>全选</span>
                <el-switch
                  v-model="selectAllGame"
                  @change="(val) => {
                    if (val) {
                      olderGameListCheck = gamesListCheck
                      gamesListCheck = gamesList.map(item => item.id)
                    } else {
                      gamesListCheck = olderGameListCheck
                    }
                  }">
                </el-switch>
              </div>
              <el-checkbox-group v-model="gamesListCheck">
                <el-checkbox
                  v-for="(item, i) in gamesList"
                  :key="i"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>

          <div class="privilege_game">
            <em>列表权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="displayList"
                active-text="不展示"
                :active-value="1"
                inactive-text="展示"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_game">
            <em>所属渠道权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="displayChannel"
                active-text="不展示"
                :active-value="1"
                inactive-text="展示"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_game">
            <em>所属游戏权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="displayGame"
                active-text="不展示"
                :active-value="1"
                inactive-text="展示"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_game">
            <em>导出权限：</em>
            <div class="ban-checkbox">
              <el-switch
                v-model="canExport"
                active-text="禁止"
                :active-value="1"
                inactive-text="允许"
                :inactive-value="0">
              </el-switch>
            </div>
          </div>

          <div class="privilege_channel">
            <em>渠道包权限：</em>
            <div>
              <div class="select-all">
                <span>全选：</span>
                <el-switch
                  v-model="selectAllChannelPackage"
                  @change="handleSelectAllChannelPackageChange">
                </el-switch>
              </div>
              <div class="filter-conditions">
                <span class="filter-conditions-label">筛选条件：</span>
                <el-select
                  class="filter-channel-group"
                  v-model="channelPackageGroup"
                  multiple
                  filterable
                  placeholder="请选择渠道包组"
                  value-key="id">
                  <el-option
                    v-for="item in channelPackageGroupList"
                    :key="item.id"
                    :label="item.group_name"
                    :value="item">
                  </el-option>
                </el-select>
                <el-input
                  class="filter-channel-search"
                  placeholder="搜索渠道"
                  v-model="searchChannelPackage"
                  clearable>
                </el-input>
                <el-button
                  size="small"
                  class="filter-action-button"
                  @click="clearChannelPackageFilters"
                >清空筛选条件</el-button>
                <el-button
                  size="small"
                  :type="isFilteredChannelPackageAllChecked ? 'warning' : 'primary'"
                  plain
              
                  class="filter-action-button"
                  :disabled="!filteredChannelPackageSelectList.length"
                  @click="toggleFilteredChannelPackages"
                >{{ isFilteredChannelPackageAllChecked ? '取消筛选结果' : '勾选筛选结果' }}</el-button>
              </div>
              <el-checkbox-group v-model="channelPackageListCheck">
                <el-checkbox
                  v-for="(item, i) in filteredChannelPackageSelectList"
                  :key="i"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          
          <!-- <div class="privilege_channel">
            <em>渠道权限：</em>
            <div>
              <div class="select-all">
                <span>全选</span>
                <el-switch
                  v-model="selectAllChannel"
                  @change="(val) => {
                    if (val) {
                      olderChannelListCheck = channelListCheck
                      channelListCheck = channelSelectList.map(item => item.id)
                    } else {
                      channelListCheck = olderChannelListCheck
                    }
                  }">
                </el-switch>
              </div>
              <div v-if="!selectAllChannel" style="margin: 10px 0;">
                <el-select
                  v-model="channelGroup"
                  multiple
                  placeholder="请选择渠道组"
                  value-key="id">
                  <el-option
                    v-for="item in channelGroupList"
                    :key="item.id"
                    :label="item.group_name"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <el-input
                style="margin-bottom: 10px;"
                placeholder="搜索渠道"
                v-model="searchChannel"
                clearable>
              </el-input>
              <el-checkbox-group v-model="channelListCheck">
                <el-checkbox
                  v-for="(item, i) in channelSelectList.filter(item => item.name.includes(searchChannel))"
                  :key="i"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div> -->
        </div>
      </div>
      <div class="privilege-submit">
        <el-button type="success" @click="submitBtn()">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";

export default {
  name: "privilegeEdit",
  components: {},
  data() {
    return {
      defaultProps: {
        children: "son",
        label: "name",
      },
      data: [],
      id: "",
      roleName: "",
      default_checked: [],
      gamesListCheck: [],
      channelListCheck: [],
      gamesList: [],
      channelSelectList: [],
      fieldObj: [],
      fieldList: {
        'user_role/list': {
          label: '角色列表',
          list: [
            {
              route: "user_role/list",
              key: "amount",
              label: '总充值金额'
            }
          ]
        }
      },
      channelGroupList: [],
      channelGroup: [],
      searchChannel: "",
      displayList: 0,
      displayChannel: 0,
      displayGame: 0,
      canExport: 0,
      // 全选
      selectAllChannel: false,
      selectAllGame: false,
      selectAllChannelPackage: false,
      // 渠道包组
      olderChannelPackageListCheck: [],
      channelPackageListCheck: [],
      channelPackageSelectList: [],
      channelPackageGroupList: [],
      channelPackageGroup: [],
      searchChannelPackage: "",
    };
  },
  computed: {
    ...mapState(["host"]),
    filteredChannelPackageSelectList() {
      const keyword = this.searchChannelPackage || "";
      const selectedGroupIds = new Set(
        this.channelPackageGroup
          .map(group => String(group.group_channel_package_ids || ""))
          .filter(Boolean)
          .join(",")
          .split(",")
          .filter(Boolean)
      );

      return this.channelPackageSelectList.filter(item => {
        const matchesGroup =
          selectedGroupIds.size === 0 || selectedGroupIds.has(String(item.id));
        const matchesKeyword = item.name.includes(keyword);
        return matchesGroup && matchesKeyword;
      });
    },
    filteredChannelPackageIds() {
      return this.filteredChannelPackageSelectList.map(item => item.id);
    },
    isFilteredChannelPackageAllChecked() {
      const checkedIdSet = new Set(this.channelPackageListCheck.map(id => String(id)));
      return (
        this.filteredChannelPackageIds.length > 0 &&
        this.filteredChannelPackageIds.every(id => checkedIdSet.has(String(id)))
      );
    },
  },
  created() {
    // 权限id
    this.id = this.$route.query.id;

    // 列表权限
    this.displayList = Number(this.$route.query.display_list)
    // 渠道权限
    this.displayChannel = Number(this.$route.query.display_channel)
    this.displayGame = Number(this.$route.query.display_game)
    // 导出权限
    this.canExport = Number(this.$route.query.export)

    // 角色权限名称
    this.roleName = this.$route.query.role_name;
    // 默认选中角色权限菜单
    let arr = this.$route.query.menu_ids;
    this.default_checked = arr.split(",");

    let games = this.$route.query.game_ids;
    // 字符串型数组
    let gameArr = games.split(",");

    // 转化成整型int数组
    gameArr.forEach((item) => {
      this.gamesListCheck.push(+item);
    });

    let channels = this.$route.query.channel_ids;
    // 字符串型数组
    let channelArr = channels.split(",");
    // 转化成整型int数组
    channelArr.forEach((item) => {
      this.channelListCheck.push(+item);
    });


    let channelPackage = this.$route.query.game_channel_package_ids;
    // 字符串型数组
    let channelPackageArr = channelPackage.split(",");
    // 转化成整型int数组
    channelPackageArr.forEach((item) => {
      this.channelPackageListCheck.push(+item);
    });

    this.getGameSelectList();
    this.getUsersList();

    // this.getchannelSelectList();
    // this.getChannelGroupList()

    this.getChannelPackageGroupList()
    this.getchannelPackageSelectList()
  },
  watch: {
    channelGroup: {
      handler (val, oldVal) {
        if (val.length < oldVal.length) {
          const target = oldVal.filter(item => !val.map(val => val.id).includes(item.id))
          if (target) {
            const arrStr = target.map(c => c.group_channel_ids).toString()
            this.channelListCheck = this.channelListCheck.filter(item => !arrStr.split(',').includes(String(item)))
          }
        } else {
          const arrStr = val.map(c => c.group_channel_ids).toString()
          this.channelListCheck = [...new Set(this.channelListCheck.concat(arrStr.split(',').map(n => Number(n))))]
        }
      }
    },
  },
  methods: {
    handleSelectAllChannelPackageChange(val) {
      if (val) {
        this.olderChannelPackageListCheck = this.channelPackageListCheck;
        this.channelPackageListCheck = this.channelPackageSelectList.map(item => item.id);
      } else {
        this.channelPackageListCheck = [];
        this.olderChannelPackageListCheck = [];
      }
    },
    updateSelectAllChannelPackageState() {
      const allIds = this.channelPackageSelectList.map(item => item.id);
      const checkedIdSet = new Set(this.channelPackageListCheck.map(id => String(id)));
      this.selectAllChannelPackage =
        allIds.length > 0 &&
        allIds.every(id => checkedIdSet.has(String(id)));
    },
    selectFilteredChannelPackages() {
      const checkedList = [...this.channelPackageListCheck];
      const checkedIdSet = new Set(checkedList.map(id => String(id)));
      this.filteredChannelPackageIds.forEach(id => {
        if (!checkedIdSet.has(String(id))) {
          checkedList.push(id);
          checkedIdSet.add(String(id));
        }
      });
      this.channelPackageListCheck = checkedList;
      this.updateSelectAllChannelPackageState();
    },
    unselectFilteredChannelPackages() {
      const filteredIds = new Set(this.filteredChannelPackageIds.map(id => String(id)));
      this.channelPackageListCheck = this.channelPackageListCheck.filter(
        id => !filteredIds.has(String(id))
      );
      this.updateSelectAllChannelPackageState();
      this.olderChannelPackageListCheck = this.channelPackageListCheck;
    },
    toggleFilteredChannelPackages() {
      if (this.isFilteredChannelPackageAllChecked) {
        this.unselectFilteredChannelPackages();
      } else {
        this.selectFilteredChannelPackages();
      }
    },
    clearChannelPackageFilters() {
      this.channelPackageGroup = [];
      this.searchChannelPackage = "";
    },
    // 游戏权限
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 渠道权限
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectList = res.data.data;
      });
    },

    submitBtn() {
      // let treeCheck = this.$refs.tree.getCheckedKeys();
      // let treeChecked = treeCheck.toString();
      let treeCheck = this.$refs.tree;
      // let array = treeCheck.getCheckedKeys().concat(treeCheck.getHalfCheckedKeys())

      // let treeChecked = treeCheck.toString();
      // let arrayTree = array.toString()
      let treeChecked = treeCheck
        .getCheckedKeys()
        .concat(treeCheck.getHalfCheckedKeys());
      let arrayTree = treeChecked.map((item) => {
        return item
      })

      let gamesListChecked = this.gamesListCheck.toString();
      let channelListChecked = this.channelListCheck.toString();
      let channelPackageListChecked = this.channelPackageListCheck.toString();
      const params = {
        id: this.id,
        role_name: this.roleName,
        menu_ids: arrayTree.toString(),
        game_ids: gamesListChecked,
        channel_ids: channelListChecked,
        display_list: this.displayList,
        display_channel: this.displayChannel,
        display_game: this.displayGame,
        export: this.canExport,
        game_channel_package_ids: channelPackageListChecked,
      }
      if (this.fieldObj?.length) {
        const field = {}
        this.fieldObj.forEach(f => {
          const [key, value] = f.split('&&')
          field[key] = value
        })
        params.field = JSON.stringify(field)
      }

      fetch({
        url: "/admin/admin_privileges/privilege_edit",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "编辑成功！",
          })
          this.$router.push({ name: "privilegeList" })
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 展示权限列表编辑数据
    getUsersList() {
      this.loadingData = true;
      fetch({
        url: "/admin/admin_privileges/privilege_edit",
        method: "POST",
        params: {
          id: this.id,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.data = res.data.data[0];
            this.default_checked = res.data.data["ids"]["menu_ids"].split(",")
            const jsonfield = res.data.data["ids"]["field"]
            if (jsonfield) {
              const field = JSON.parse(jsonfield)
              let list = []
              for (let key in field) {
                list.push(key + "&&" + field[key])
              }
              this.fieldObj = list
            }
          }
        })
        .finally(() => {});
    },
    // 展示渠道列表数据
    getChannelGroupList() {
      fetch({
        url: "/admin/channel_groups/list",
        method: "GET",
        params: {
          per_page: 100,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.channelGroupList = res.data.data.data;
          }
        })
    },
    // 展示渠道包组列表数据
    getChannelPackageGroupList() {
      fetch({
        url: "/admin/channel_package_group/list",
        method: "GET",
        params: {
          per_page: 100,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.channelPackageGroupList = res.data.data.data;
          }
        })
    },

    // 渠道包组权限
    getchannelPackageSelectList() {
      fetch({
        url: "/admin/game_channel_packages/channel_package_select",
        method: "GET",
      }).then((res) => {
        this.channelPackageSelectList = res.data.data;
      });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.privilege-detail {
  display: flex;
  align-items: center;
  padding-bottom: 30px;
  .title {
    font-size: 24px;
  }
  .el-input {
    width: 280px;
  }
}
.privilege-detail > span {
  display: block;
  margin-right: 10px;
}
.privilege-detailRE {
  align-items: flex-start;
  padding-bottom: 0;
  .tree {
    flex: 1;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}

.privilege_game,
.privilege_channel {
  margin: 20px 0;
  display: flex;
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  em {
    display: inline-block;
    min-width: 90px;
    font-style: normal;
    position: relative;
    top: -2px;
    font-size: 14px;
    white-space: nowrap;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    min-width: 200px;
    padding: 5px;
  }
}
.privilege_game > div,
.privilege_channel > div {
  margin-left: 10px;
}
.privilege-submit {
  text-align: right;
  margin: 20px 0;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(0, 0, 0, 0.9);
}
.filter-conditions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
  flex-wrap: nowrap;
}
.filter-conditions-label {
  flex: 0 0 auto;
  color: inherit;
  white-space: nowrap;
}
.filter-channel-group,
.filter-channel-search {
  width: 280px;
}
.filter-action-button {
  min-width: 130px;
  height: 36px;
  padding: 0 16px;
  font-size: 14px;
}
</style>
